// Fake data for the Purchase Plan wireframe. Shapes follow the Needs Buying page so
// the real recommendation can be dropped in later.

export type Status = "buy" | "little_history" | "no_plan" | "enough"

export interface Product {
  id: string
  name: string
  sku: string
  supplier: string | null
  moq: number | null
  leadTimeDays: number
  status: Status
  suggested: number | null
  onHand: number
  incoming: number
  planned: number | null
  reasons: string[]
}

export interface PlanProduct {
  productId: string
  quantity: number
  supplier: string
  moq: number | null
}

export interface Plan {
  id: string
  name: string
  byDate: string
  products: PlanProduct[]
}

export const SUPPLIERS = ["Thien Phuc", "Infly", "Ningbo Semi", "Shizencos", "Xiteyou", "Seago", "Lena", "Caco"]

export const PRODUCTS: Product[] = [
  {
    id: "p1", name: "Halio Facial Cleansing Brush", sku: "HAL-FCB-01", supplier: "Infly", moq: 1000, leadTimeDays: 60,
    status: "buy", suggested: 2400, onHand: 820, incoming: 500, planned: 3100,
    reasons: [
      "Vietnam: plans to sell 2,600 by Jan 18. Has 700 on hand and 500 arriving Oct 30. Short 1,900.",
      "International: plans to sell 500 by Jan 18. Has 120 on hand, nothing arriving. Short 500.",
    ],
  },
  {
    id: "p2", name: "Lustre Rose Lip Tint", sku: "LUS-RLT-03", supplier: "Thien Phuc", moq: 3000, leadTimeDays: 45,
    status: "buy", suggested: 3000, onHand: 1900, incoming: 0, planned: 3200,
    reasons: ["Vietnam: plans to sell 3,200 by Dec 19. Has 1,900 on hand, nothing arriving. Short 1,800, raised to the minimum order."],
  },
  {
    id: "p3", name: "Okame Cotton Pads 120pcs", sku: "OKA-CP-120", supplier: null, moq: null, leadTimeDays: 75,
    status: "buy", suggested: 5200, onHand: 2100, incoming: 1000, planned: 7400,
    reasons: ["Vietnam: plans to sell 7,400 by Feb 17. Has 2,100 on hand and 1,000 arriving Nov 12. Short 5,200."],
  },
  {
    id: "p4", name: "Halio Sonic Whitening Toothbrush", sku: "HAL-SWT-02", supplier: "Infly", moq: 500, leadTimeDays: 60,
    status: "buy", suggested: 900, onHand: 310, incoming: 0, planned: 1050,
    reasons: ["Vietnam: plans to sell 1,050 by Jan 18. Has 310 on hand, nothing arriving. Short 900."],
  },
  {
    id: "p5", name: "Lustre Velvet Blush", sku: "LUS-VB-05", supplier: null, moq: null, leadTimeDays: 75,
    status: "buy", suggested: 1300, onHand: 450, incoming: 0, planned: 1500,
    reasons: ["Vietnam: plans to sell 1,500 by Feb 17. Has 450 on hand, nothing arriving. Short 1,300."],
  },
  {
    id: "p6", name: "Shizen Green Tea Cleanser", sku: "SHI-GTC-01", supplier: "Shizencos", moq: 2000, leadTimeDays: 50,
    status: "little_history", suggested: null, onHand: 600, incoming: 0, planned: 900,
    reasons: ["Vietnam: only 5 weeks of sales so far, too little to suggest a quantity. Sold 410 in the last 90 days."],
  },
  {
    id: "p7", name: "Halio Replacement Brush Heads", sku: "HAL-RBH-04", supplier: "Infly", moq: 2000, leadTimeDays: 60,
    status: "no_plan", suggested: null, onHand: 340, incoming: 0, planned: null,
    reasons: ["Vietnam: no plan for this product. Sold 1,250 in the last 90 days. Has 340 on hand."],
  },
  {
    id: "p8", name: "Seago Kids Toothbrush", sku: "SEA-KT-02", supplier: "Seago", moq: 1000, leadTimeDays: 40,
    status: "no_plan", suggested: null, onHand: 90, incoming: 0, planned: null,
    reasons: ["Vietnam: no plan for this product. Sold 380 in the last 90 days. Has 90 on hand."],
  },
  {
    id: "p9", name: "Lustre Matte Lipstick", sku: "LUS-ML-07", supplier: "Thien Phuc", moq: 3000, leadTimeDays: 45,
    status: "enough", suggested: null, onHand: 6400, incoming: 3000, planned: 4100,
    reasons: ["Vietnam: plans to sell 4,100 by Dec 19. Has 6,400 on hand and 3,000 arriving Nov 5. Enough."],
  },
  {
    id: "p10", name: "Ningbo Silicone Face Mask Brush", sku: "NIN-MB-01", supplier: "Ningbo Semi", moq: 5000, leadTimeDays: 70,
    status: "enough", suggested: null, onHand: 8800, incoming: 0, planned: 2300,
    reasons: ["Vietnam: plans to sell 2,300 by Feb 7. Has 8,800 on hand. Enough."],
  },
]

export const PLANS: Plan[] = [
  {
    id: "oct", name: "October buying", byDate: "2026-10-15",
    products: [
      { productId: "p1", quantity: 2400, supplier: "Infly", moq: 1000 },
      { productId: "p4", quantity: 900, supplier: "Infly", moq: 500 },
      { productId: "p2", quantity: 3000, supplier: "Thien Phuc", moq: 3000 },
      { productId: "p3", quantity: 5000, supplier: "", moq: null },
      { productId: "p7", quantity: 2000, supplier: "Infly", moq: 2000 },
      { productId: "p6", quantity: 1500, supplier: "Shizencos", moq: 2000 },
      { productId: "p8", quantity: 1000, supplier: "Seago", moq: 1000 },
    ],
  },
  {
    id: "tet", name: "Tet restock", byDate: "2026-11-30",
    products: [
      { productId: "p9", quantity: 3000, supplier: "Thien Phuc", moq: 3000 },
      { productId: "p5", quantity: 1300, supplier: "", moq: null },
    ],
  },
]

export const productById = (id: string) => PRODUCTS.find((p) => p.id === id)!
export const units = (value: number) => value.toLocaleString("en-US")

const DAY = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" })
export const longDate = (iso: string) => (iso ? DAY.format(new Date(`${iso}T00:00:00Z`)) : "No date yet")
